import { api } from "./config";

export async function GetAgentList() {
  try {
    const response = await api().get("/agent/list");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetAllAgents() {
  try {
    const response = await api().get("/agent/all");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetAgentDetailById(id) {
  try {
    const response = await api().get("/agent/detail", { params: { id } });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function CreateAgent(data) {
  try {
    const response = await api().post("/agent/create", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function UpdateAgent(data) {
  try {
    const response = await api().patch("/agent/update", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function ToggleAgent(id) {
  try {
    const response = await api().patch("/agent/toggle", { id });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetAgentWallet(id) {
  try {
    const response = await api().get("/agent/wallet", { params: { id } });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}
